﻿$.fn.dxCtrlContentSondagePageItem = function custom_dxCtrlContentSondagePageItem(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlcontentsondagepageitem dx-ctrl");
        this.createInstance(new cdxCtrlContentSondagePageItem(this, option));
    }
    return this;
}

window.cdxCtrlContentSondagePageItem = function (container, option) {
    var Me = this;


    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    var dxScrollDetail = null
    function mConstruit() {
        container.empty()

        container.css("font-family", "barlow condensed")
        $("<span>" + option.dataPage.lst_question.length + " <i class='fas fa-circle-question dx-theme-accent-as-text-color'></i></span>").appendTo(container).attr("title", option.dataPage.lst_question.length + " question" + (option.dataPage.lst_question.length > 1 ? "s" : ""))
        $("<span>&nbsp;&bull;&nbsp;</span>").appendTo(container)
        $("<span style='font-weight:bold;'>" + option.dataPage.titre + "</span>").appendTo(container)
        if (option.dataPage.id_page == -1) {
            container.attr("title",  "<div style='text-align:left;'>" + container.html() + "<br/>Cette page est la dernière page de votre sondage.<br/>Elle ne peut être supprimé.<br/>C'est quand votre répondeur arrive sur cette page que le sondage est marqué comme complété.<br/>Sur cette page, vous pouvez définir des conditions de satisfaction pour l'affichage des questions et vous ne pouvez que saisir du texte ou recueillir un avis.</div>")
        } else {
            container.attr("title", container.html())
        }

    }

    this.element = function () { return container }

    mConstruit();
}